<template lang="html" src="./Company.html" />
<script>
import { useStore } from "@/store/store.js"
import mixins from "../../../../../Mixins.js";
import WholeMultiselect from "@/components/whole-multiselect/WholeMultiselect.vue";
export default {
  mixins: [mixins],
  components: { WholeMultiselect },
  data() {
    return {
      company: {},
      name: "",
      cnpj: "",
      email: "",
      clientName: null,
      partners: [],
      partnerId: null,
      active: false,
      titleLabel: "",
      legalRepresentative: null,
      rhRepresentative: null,
      phone: null,
      newCompany: true,
      statusActive: false,
      statusInactive: false,
      titleCard: "Cadastro de novas empresas",
      subtitleCard:
        "Cadastre as novas empresas. Na conclusão desta operação o sistema enviará, via e-mail, um convite para a empresa cadastrada entrar no sistema.",
      address: {
        zipcode: "",
        street: "",
        number: "",
        complement: "",
        city: "",
        state: ""
      },
      companyName: "",
      validZipcode: true,
      invalidFields: {
        name: false,
        companyName: false,
        email: false,
        cnpj: false,
        zipcode: false,
        street: false,
        number: false,
        city: false,
        state: false,
        partnerId: false,
      },
      clicked: false,
      disable: {
        street: false,
        city: true,
        state: true,
      },
    };
  },
  setup () {
    const store = useStore()

    return {
      getAddressByZipcode: (cep) => store.dispatch("getAddressByZipcode", cep),
    }
  },
  mounted() {
    const vm = this;
    vm.getPartners();
  },
  watch: {
    email : function() {
      let vm= this;
      vm.invalidFields.email = !vm.validateEmail(vm.email) && vm.clicked;
    },
    partnerId : function() {
      let vm= this;
      vm.invalidFields.partnerId = vm.testNullUndefinedEmpty(vm.partnerId.id) && vm.clicked;
    },
    name : function() {
      let vm= this;
      vm.invalidFields.name = vm.testNullUndefinedEmpty(vm.name) && vm.clicked;
    },
    companyName : function() {
      let vm= this;
      vm.invalidFields.companyName = vm.testNullUndefinedEmpty(vm.companyName) 
       && vm.clicked;
    },
    cnpj : function() {
      let vm= this;
      vm.invalidFields.cnpj = !vm.validateCNPJ(vm.cnpj) && vm.clicked;
    },
    'address.zipcode' : function() {
      let vm= this;
      vm.invalidFields.zipcode =  (vm.testNullUndefinedEmpty(vm.address)
       || vm.testNullUndefinedEmpty(vm.address.zipcode)) && vm.clicked;
    },
    'address.street': function() {
      let vm= this;
      vm.invalidFields.street = (vm.testNullUndefinedEmpty(vm.address) 
       || vm.testNullUndefinedEmpty(vm.address.street)) && vm.clicked;
    },
    'address.number' : function() {
      let vm= this;
      vm.invalidFields.number = (vm.testNullUndefinedEmpty(vm.address) 
       || vm.testNullUndefinedEmpty(vm.address.number)) && vm.clicked;
    },
    'address.city' : function() {
      let vm= this;
      vm.invalidFields.city = (vm.testNullUndefinedEmpty(vm.address) 
       || vm.testNullUndefinedEmpty(vm.address.city)) && vm.clicked;
    },
    'address.state' : function() {
      let vm= this;
      vm.invalidFields.state = (vm.testNullUndefinedEmpty(vm.address) 
       || vm.testNullUndefinedEmpty(vm.address.state)) && vm.clicked;
    },
  },
  methods: {
    clickActiveStatus() {
      const vm = this;
      vm.statusActive = true;
      vm.statusInactive = false;
    },
    clickInactiveStatus() {
      const vm = this;
      vm.statusActive = false;
      vm.statusInactive = true;
    },
    validateFields() {
      const vm = this;

      let invalidFields = false;

      vm.invalidFields.email = !vm.validateEmail(vm.email);
      vm.invalidFields.name = vm.testNullUndefinedEmpty(vm.name);
      vm.invalidFields.companyName = vm.testNullUndefinedEmpty(vm.companyName); 
      vm.invalidFields.cnpj = !vm.validateCNPJ(vm.cnpj);
      vm.invalidFields.partnerId = vm.testNullUndefinedEmpty(vm.partnerId);
      invalidFields = vm.invalidFields.email 
        || vm.invalidFields.name
        || vm.invalidFields.companyName
        || vm.invalidFields.cnpj
        || vm.invalidFields.partnerId;

      if (!invalidFields) {
        vm.$route.params.id ? vm.putCompany() : vm.postCompany();
      }else {
        vm.$vs.notify({
          title: "Atenção",
          text:
            'Campos obrigatórios não preenchidos ou inválidos, verifique os "Dados gerais"',
          color: "warning",
          position: "top-right"
        });
      }
    },
    putCompany() {

      const vm = this;
      let company = {
        id: vm.$route.params.id,
        active: vm.active,
        countEmployees: vm.company.countEmployees,
        name: vm.name,
        cnpj: vm.cnpj,
        companyName: vm.companyName,
        email: vm.email,
        address: vm.address,
        partnerId: vm.partnerId,
        clientName: this.clientName.name,
      };
      if (vm.legalRepresentative != null) {
        company.legalRepresentative = vm.legalRepresentative;
      }
      if (vm.rhRepresentative != null) {
        company.rhRepresentative = vm.rhRepresentative;
      }
      if (vm.phone != null) {
        company.phone = vm.phone
          .replace("(", "")
          .replace(")", "")
          .replace("-", "");
      }
      vm.axios
        .put(vm.$store.state.filooServer + "admin/companies/" + vm.$route.params.id, company, {
          headers: { Authorization: vm.$session.get("bearerDefault") }
        })
        .then(function(response) {
          if (response.status == 200) {
            vm.$swal({
              title: "Sucesso!",
              text:
                "Alterações realizadas com sucesso.",
              icon: "success"
            }).then(function() {
              vm.clicked = false;
              vm.getCompany(response.data.id);
            });
          }
        })
        .catch(function (error) {
          if (error.response && error.response.status === 400) {
            const message = error.response.data.message;

            if (message.includes("CNPJ")) {
              vm.$swal({
                title: "Atenção!",
                text: "Já existe uma empresa cadastrada com o mesmo CNPJ!",
                icon: "error"
              });
              vm.invalidFields.cnpj = true;
            } else if (message.includes("E-Mail") || message.includes("e-mail")) {
              vm.$swal({
                title: "Atenção!",
                text: "Já existe uma empresa cadastrada com o mesmo e-mail!",
                icon: "error"
              });
              vm.invalidFields.email = true;
            } else {
              vm.$swal({
                title: "Erro!",
                text: message || "Erro ao cadastrar a empresa.",
                icon: "error"
              });
            }
          } else {
            vm.$swal({
              title: "Erro!",
              text: "Erro inesperado ao cadastrar empresa. Tente novamente.",
              icon: "error"
            });
          }
        });
    },
    getCompany(idCompany) {
      const vm = this;
      vm.axios
        .get(vm.$store.state.filooServer + "company/companies/" + idCompany, {
          headers: { Authorization: vm.$session.get("bearer") }
        })
        .then(function(response) {
          if (response.status === 200) {
            vm.newCompany = false;
            vm.company = response.data;
            vm.fillFieldsCompany();
          }
        });
    },
    getPartners() {
      const vm = this;
      vm.axios
        .get(vm.$store.state.filooServer + "partner/get-partners",{
            headers: { Authorization: vm.$session.get("bearerDefault") },
          })
        .then(function (response) {
          if (response.status === 200) {
            vm.partners = response.data;
            if (vm.$route.params.id) {
              vm.titleCard = "";
              vm.subtitleCard = "";
              vm.getCompany(vm.$route.params.id);
            }
          }
        });
    },
    fillFieldsCompany() {
      const vm = this;
      vm.clicked = true ;
      vm.name = vm.company.name;
      vm.email = vm.company.email;
      vm.companyName = vm.company.companyName;
      vm.cnpj = vm.company.cnpj;
      vm.active = vm.company.active;
      vm.partnerId = vm.company.partnerId ? vm.partners.find(partner => partner.id === vm.company.partnerId.id) : null;
      this.clientName = this.partners.find(pack => pack.id === this.company.partnerId.id);

      if (vm.active == true) {
        vm.titleLabel = "Ativa";
      } else {
        vm.titleLabel = "Inativa";
      }
      vm.address = vm.testNullUndefinedEmpty(vm.company.address)?
        { zipcode: "", street: "", number: "", complement: "", city: "", state: ""}
         : vm.company.address;

      if (vm.testNullUndefinedEmpty(vm.company.address)) {
          vm.invalidFields.zipcode = true;
          vm.invalidFields.street = true;
          vm.invalidFields.number = true;
          vm.invalidFields.city = true;
          vm.invalidFields.state = true;
          vm.disable.city = false;
          vm.disable.state = false;
          vm.disable.street = false;
      } else {
        vm.validateAddressFields();
        vm.disable.city = !vm.testNullUndefinedEmpty(vm.address.city);
        vm.disable.state = !vm.testNullUndefinedEmpty(vm.address.state);
        vm.disable.street = !vm.testNullUndefinedEmpty(vm.address.street);
      }

      vm.phone = vm.company.phone? vm.company.phone : null;
      vm.rhRepresentative =  vm.company.rhRepresentative ? vm.company.rhRepresentative : null;
      vm.legalRepresentative  = vm.company.legalRepresentative ? vm.company.legalRepresentative : null;
    },
    clickStatus() {
      const vm = this;
      if (vm.active == true) {
        vm.titleLabel = "Inativa";
      }
      if (vm.active == false) {
        vm.titleLabel = "Ativa";
      }
    },
    resendPassword() {
      const vm = this;
      vm.axios
        .put(
          vm.$store.state.filooServer +
            "admin/companies/" +
            vm.$route.params.id +
            "/resend-email",
          {
            headers: { Authorization: vm.$session.get("bearerDefault") }
          }
        )
        .then(function(response) {
          if (response.status == 200) {
            vm.$swal({
              title: "Sucesso!",
              text:
                "Operação realizada com sucesso, verifique sua caixa de entrada e de spam.",
              icon: "success"
            });
          }
        })
        .catch(function(error) {
          if(error.data.message.toString().includes("Acesso")) {
            vm.$swal({
              title: "Acesso Negado!",
              text:
                "Não foi possível executar esta operação. Entre em contato com o administrador do sistema ",
              icon: "error"
            });
          } else {
            if(error.data.message.toString().includes("email")) {
              vm.$swal({
                title: "Atenção!",
                text:
                  "Não foi possível executar esta operação. Não há um e-mail cadastrado para o reenvio",
                icon: "error"
              });
            } else {
              vm.$swal({
                title: "Atenção!",
                text:
                  "Não foi possível executar esta operação. Verifique se o e-mail cadastrado é válido e se" +
                  " a caixa de entrada ou de spam estão lotadas. Caso o problema persista entre em contato" +
                  " com o administrador do sistema ",
                icon: "error"
              });
            }
          }
        });
    },
    postCompany() {
      const vm = this;
      let company = {
        active: false,
        name: vm.name,
        cnpj: vm.cnpj,
        companyName: vm.companyName,
        email: vm.email,
        address: vm.address,
        partnerId: vm.partnerId,
        clientName: this.clientName.name,
      };
      if (vm.legalRepresentative != null) {
        company.legalRepresentative = vm.legalRepresentative;
      }
      if (vm.rhRepresentative != null) {
        company.rhRepresentative = vm.rhRepresentative;
      }
      if (vm.phone != null) {
        company.phone = vm.phone
          .replace("(", "")
          .replace(")", "")
          .replace("-", "");
      }
      vm.axios
        .post(vm.$store.state.filooServer + "admin/companies", company, {
          headers: { Authorization: vm.$session.get("bearerDefault") }
        })
        .then(function(response) {
          if (response.status == 201) {
            vm.clicked = false;
            vm.$swal({
              title: "Sucesso!",
              text:
                "Dados registrados com sucesso. A empresa cadastrada receberá convite via e-mail com instruções para acessar o sistema.",
              icon: "success"
            }).then(function() {
              vm.$router.push("/registered-companies");
            });
          }
        })
        .catch(function (error) {
          if (error.response && error.response.status === 400) {
            const message = error.response.data.message;

            if (message.includes("CNPJ")) {
              vm.$swal({
                title: "Atenção!",
                text: "Já existe uma empresa cadastrada com o mesmo CNPJ!",
                icon: "error"
              });
              vm.invalidFields.cnpj = true;
            } else if (message.includes("E-Mail") || message.includes("e-mail")) {
              vm.$swal({
                title: "Atenção!",
                text: "Já existe uma empresa cadastrada com o mesmo e-mail!",
                icon: "error"
              });
              vm.invalidFields.email = true;
            } else {
              vm.$swal({
                title: "Erro!",
                text: message || "Erro ao cadastrar a empresa.",
                icon: "error"
              });
            }
          } else {
            vm.$swal({
              title: "Erro!",
              text: "Erro inesperado ao cadastrar empresa. Tente novamente.",
              icon: "error"
            });
          }
        });
    },
    async getAddressData(zipcode) {
      this.invalidFields.zipcode = false
      this.invalidFields.number = false
      this.invalidFields.street = false
      this.invalidFields.state = false
      this.invalidFields.city = false

      this.validZipcode = zipcode && /^[0-9]{5}-[0-9]{3}$/.test(zipcode)

      if (this.validZipcode) {
        const response = await this.getAddressByZipcode(zipcode)
        this.validZipcode = response && response.address

        if (this.validZipcode) {
          this.address.zipcode = response.address.zipcode
          this.address.city = response.address.city
          this.address.state = response.address.state
          this.address.street = response.address.street
        } else {
          this.address.city = ""
          this.address.state = ""
          this.address.street = ""
        }
      }

      this.disable.street = this.validZipcode && !!this.address.street
      this.disable.city = this.validZipcode && !!this.address.city
      this.disable.state = this.validZipcode && !!this.address.state
    },

    validateAddressFields() {
      const vm = this;
      vm.invalidFields.zipcode =  (vm.testNullUndefinedEmpty(vm.address)
       || vm.testNullUndefinedEmpty(vm.address.zipcode))
      vm.invalidFields.street = (vm.testNullUndefinedEmpty(vm.address) 
       || vm.testNullUndefinedEmpty(vm.address.street));
      vm.invalidFields.number = (vm.testNullUndefinedEmpty(vm.address) 
       || vm.testNullUndefinedEmpty(vm.address.number));
      vm.invalidFields.city = (vm.testNullUndefinedEmpty(vm.address) 
       || vm.testNullUndefinedEmpty(vm.address.city));
      vm.invalidFields.state = (vm.testNullUndefinedEmpty(vm.address) 
       || vm.testNullUndefinedEmpty(vm.address.state));
    }
  }
};
</script>
<style lang="scss" src="./Company.scss" />